import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import IntroCards from 'components/1080p_Series_CGI_List/Network_Menu/networkCGI';
import NavButtons from 'components/1080p_Series_CGI_List/NavButtons';
import * as React from 'react';
export default {
  BreadCrumbs,
  SEOHelmet,
  IntroCards,
  NavButtons,
  React
};